export default __webpack_public_path__ + "static/media/twitter.87682341.svg";